import styles from './ProfileMenu.module.css'

const ProfileMenu = () => {

    const openSupport = () => {
        const url = "https://t.me/zelinskiy1"

        window.Telegram?.WebApp.openTelegramLink(url)
    }

    return (
        <div className={styles.menuContainer}>
            <button className={styles.menuItem}>
                <div className={styles.menuItemContent}>
                    <div className={styles.channelIcon}/>
                    <span className={styles.menuItemText}>Официальный канал</span>
                </div>
                <div className={styles.chevron}/>
            </button>

            <button className={styles.menuItem}>
                <div className={styles.menuItemContent}>
                    <div className={styles.withdrawIcon}/>
                    <span className={styles.menuItemText}>Выводы</span>
                </div>
                <div className={styles.chevron}/>
            </button>

            <button onClick={openSupport} className={`${styles.menuItem} ${styles.menuItemLast}`}>
                <div className={styles.menuItemContent}>
                    <div className={styles.supportIcon}/>
                    <span className={styles.menuItemText}>Тех поддержка</span>
                </div>
                <div className={styles.chevron}/>
            </button>
        </div>
    )
}

export default ProfileMenu;